import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto;
`;

export const WrapperTitle = styled.h1`
  font-size: 18px;
  font-weight: 900;
  margin-bottom: 16px;
  color: #161d1f;
`;

export const WrapperCard = styled.div`
  padding: 24px 24px;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0px 2px 8px -4px rgba(176, 192, 202, 0.2);
`;

export const WrapperCardDescription = styled.div`
  margin-bottom: 16px;
  font-size: 14px;
  color: #161d1f;
`;

export const WrapperCardGrid = styled.div`
  display: grid;
  grid-row-gap: 16px;
  grid-column-gap: 16px;
  grid-template-columns: repeat(1, 1fr);

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);

    > div {
      &:nth-of-type(1),
      &:nth-of-type(2),
      &:nth-of-type(3),
      &:nth-of-type(4),
      &:nth-of-type(7),
      &:nth-of-type(8) {
        grid-column: 2 span;
      }
    }
  }
`;

export const WrapperCheckbox = styled.div<{
  disabled: boolean;
}>`
  display: flex;
  align-items: center;

  > span {
    font-size: 14px;
    color: ${(props) => (props.disabled ? '#8090BB' : '#161D1F')};
  }
`;
